import moment from 'moment';
import _ from 'underscore';
import Promise from 'bluebird';
import jQuery from 'jquery';

import admissionGroupStatService from 'src/api/admissionGroupStat';

function EventsCtrl($scope, $state, $stateParams, $q, $timeout, alertService, sdkVenueService, sdkUtils, eventService, dateUtilsService, managementUserService, organizationService, userPreferencesService, $location, venueService, urlService, visibilityHelpersService, sdkTicketStatService, mapperService, permissionService) { //eslint-disable-line
  const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.loading = true;

  $scope.currentDate = moment();

  $scope.eventPageNumber = 1;
  $scope.eventPageSize = 5;

  $scope.eventSearchType = 'NAME';

  $scope.isPrivate = function(event) {
    return visibilityHelpersService.isPrivate(event);
  };

  $scope.isPublished = function(event) {
    const now = moment().startOf('day');

    const eventDate = event.date.startOf('day');

    return visibilityHelpersService.isPublished(event) && eventDate.diff(now, 'days') >= 0;
  };

  $scope.getEventScheduledText = function(event) {
    if (!event) return '';

    if (!event.enabledOn) return false;

    if (!visibilityHelpersService.isPublished(event)) return false;

    return event.enabledOn.isAfter(moment());
  };

  $scope.getPublicEventsUrl = _getPublicEventsUrl;

  $scope.changeVenue = _changeVenue;

  $scope.resetPaging = function() {
    $scope.eventPageNumber = 1;
  };

  $scope.getPreviousPageOfEvents = function($event) {
    if ($event) {
      $event.preventDefault();
    }

    $scope.loading = true;

    $scope.eventPageNumber -= 1;

    return _getEvents(true)
      .then(() => {
        $scope.loading = false;
      });
  };

  $scope.getNextPageOfEvents = function($event) {
    if ($event) {
      $event.preventDefault();
    }

    $scope.loading = true;
    $scope.eventPageNumber += 1;

    return _getEvents(true)
      .then(() => {
        $scope.loading = false;
      });
  };

  $scope.eventSearch = {
    search: null,
    dateRange: {
      startDate: moment(),
      endDate: moment()
    }
  };

  $scope.changeSearchType = function(type, $event) {
    if ($event) {
      $event.preventDefault();
    }

    if (type === 'NAME') {
      $scope.eventSearch.dateRange = {
        startDate: moment(),
        endDate: moment()
      };
    } else if (type === 'DATE') {
      delete $scope.eventSearch.search;

      $timeout(() => {
        jQuery('.event-date-range-picker').trigger('click');
      }, 300);
    }

    $scope.eventSearchType = type;
  };

  $scope.searchEvents = _.debounce(() => {
    $scope.loading = true;

    if (!$scope.eventSearch.search || !$scope.eventSearch.search.length) {
      $scope.eventSearch.dateRange = {
        startDate: moment(),
        endDate: moment()
      };
      delete $scope.eventSearch.search;
    }

    return _getEvents()
      .then(() => {
        $scope.loading = false;
      });
  }, 300);

  $scope.searchEventsByDate = function() {
    if (!$scope.eventSearch.dateRange) return null;

    $scope.loading = true;

    return _getEvents()
      .then(() => {
        $scope.loading = false;
      });
  };

  $scope.dateRangePickerOptions = {
    locale: {
      format: 'MM/DD/YYYY'
    },
    showDropDowns: true,
    parentEl: '.event-search-date-field',
    eventHandlers: {
      'apply.daterangepicker': $scope.searchEventsByDate
    },
    ranges: {
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'Last Month': [moment().subtract(1, 'month'), moment()],
      'Last 6 Months': [moment().subtract(6, 'month'), moment()]
    }
  };

  $scope.clearEventSearch = function($event) {
    if ($event) {
      $event.preventDefault();
    }

    $scope.eventSearch.dateRange = {
      startDate: moment(),
      endDate: moment()
    };
    delete $scope.eventSearch.search;

    $scope.loading = true;

    $scope.eventSearchType = 'NAME';

    return _getEvents()
      .then(() => {
        $scope.loading = false;
      });
  };

  _getVenues()
    .then(() => {
      if (!$scope.venues.length) {
        $scope.noVenues = true;
        $scope.loading = false;

        return null;
      }

      return $q.all([
          _getPermissions(),
          _getEvents()
        ])
        .finally(() => {
          $scope.loading = false;
        });
    });

  function _getPermissions() {
    const canWrite = permissionService.canWriteReservations($scope.venue.id);
    const canReadPerformanceReports = permissionService.canReadPerformanceReports($scope.venue.id);

    return $q.all({
      canWrite,
      canReadPerformanceReports
    }).then(results => {
      $scope.canWrite = results.canWrite;
      $scope.canReadPerformanceReports = results.canReadPerformanceReports;
    });
  }

  function _changeVenue(venue, $event) {
    if (!venue) return;
    if ($event) $event.preventDefault();

    $scope.venue = venue;
    $scope.venueId = venue.id;

    userPreferencesService.setDefaultVenue($scope.venue.id);

    venueService.setCurrentVenue(venue);

    $location.search('venueId', $scope.venue.id);

    $scope.loading = true;

    $scope.clearEventSearch();

    _getEvents()
      .finally(function() {
        $scope.loading = false;
      });
  }

  function _getVenues() {
    return sdkVenueService.listByOrganizationId(currentUserOrganization.id, {
        fields: [
          'name',
          'id',
          'default_poster',
          'schedule',
          'company',
          'slug',
          'enable',
          'location'
        ].join(',')
      })
      .then(function(venues) {
        $scope.venues = venues;

        if (!$scope.venues.length) {
          $scope.noVenues = true;
          return;
        }

        $scope.venuesIndexedById = _.indexBy($scope.venues, 'id');

        let defaultVenue = _.findWhere($scope.venues, {
          id: $stateParams.venueId ? $stateParams.venueId : userPreferencesService.getDefaultVenue()
        });

        defaultVenue = defaultVenue || $scope.venues[0];

        $scope.venue = $scope.venue || defaultVenue;

        venueService.setCurrentVenue($scope.venue);
      })
      .catch(function(error) {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _getEvents(page) {
    const start = $scope.eventSearchType === 'DATE' ?
      dateUtilsService.toUTCTimestampWithoutTime($scope.eventSearch.dateRange.startDate) :
      undefined;
    const end = $scope.eventSearchType === 'DATE' ? dateUtilsService.toUTCTimestampWithoutTime($scope.eventSearch.dateRange.endDate) : undefined; //if a specific date is selected, must pass an endDate

    if (!page) {
      $scope.resetPaging();
    }

    const query = {
      start,
      end,
      sort: 'date',
      skip: ($scope.eventPageNumber - 1) * $scope.eventPageSize,
      limit: $scope.eventPageSize,
      search: $scope.eventSearch.search || null,
      enabledOnMax: new Date(2100, 1, 1) //send a date way in the future because
    };

    return eventService.listByVenueId($scope.venue.id, query)
      .then(events => {
        $scope.events = events.map(event => {
          const mappedEvent = mapperService.mapEventToUI(event);

          mappedEvent.venue = $scope.venuesIndexedById[event.venue];

          const seoPathname = (mappedEvent.seoPathname) ? mappedEvent.seoPathname : mappedEvent.id;

          mappedEvent.publicPageURL = urlService.getEventPublicPageUrl(seoPathname, {});

          return mappedEvent;
        });
      })
      .then(() => {
        if (!$scope.canReadPerformanceReports) return null;

        return _getTicketStatsByEvents($scope.events);
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _getPublicEventsUrl(venue) {
    if (!venue) return null;

    const urlId = (venue.seoPathname) ? venue.seoPathname : venue.id;
    return urlService.getPublicVenueEventPageUrl(urlId);
  }

  function _getTicketStatsByEvents(events) {
    const promises = events.map(event => {
      return $q.resolve(admissionGroupStatService.findByIdAndVenueId(event.date.format('x'), $scope.venue.id));
    });

    return Promise.all(promises)
      .then(results => {
        $scope.admissionGroupStats = results.map((result, index) => {
          const event = events[index];

          event.admissionGroupStats = result.data;

          return result.data;
        });
      });
  }
}

EventsCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  '$timeout',
  'alertService',
  'jsSdk.venue',
  'jsSdk.utils',
  'jsSdk.event',
  'dateUtilsService',
  'jsSdk.managementUser',
  'organizationService',
  'userPreferencesService',
  '$location',
  'venueService',
  'urlService',
  'visibilityHelpersService',
  'jsSdk.ticketStat',
  'mapperService',
  'permissionService'
];

export default EventsCtrl;



// WEBPACK FOOTER //
// ./src/components/events/eventsCtrl.js